<template>
    <row >
        <div class="d-none d-sm-block col-xl-4 col-md-4 col-sm-3 col-xs-12 text-center p-4">
            <img style="height: 60px" alt="IGAPS" src="logo.png">
        </div>
        <div class="col-xl-4 col-md-4 col-sm-6 col-xs-12 text-center p-4">
            <img style="height: 100px" alt="Prefeitura de Biritiba Mirim" src="logo.png">
        </div>
        <div class="d-none d-sm-block col-xl-4 col-md-4 col-sm-3 col-xs-12 text-center p-4">
            <img style="height: 60px" alt="Prefeitura de Biritiba Mirim" src="logo.png">
        </div>
        <div class="d-block d-sm-none col-xl-4 col-md-4 col-sm-3 col-xs-6 col-6 text-center p-4">
            <img style="height: 45px" alt="Prefeitura de Biritiba Mirim" src="logo.png">
        </div>
        <div class="d-block d-sm-none col-xl-4 col-md-4 col-sm-3 col-xs-6 col-6 text-center p-4">
            <img style="height: 45px" alt="Prefeitura de Biritiba Mirim" src="logo.png">
        </div>
    </row>
</template>

<script>
    import Row from "@/components/Row";
    export default {
        name: "HeaderLogos",
        components: {Row}
    }
</script>

<style scoped>
    .logo-top{
        @media screen() {

        }
    }
</style>